export default {
  "videoAlert_notFound": "Video no encontrado"
}